/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { useLayout } from '../core';
import { KTSVG } from 'src/_metronic/helpers';
import Restricted from 'src/app/permissions/restricted';
import ShortcutBar from 'src/app/shortcuts/ShortcutBar';
import SupportFeedbackButton from 'src/app/components/support-feedback/SupportFeedbackButton';
import { DesktopDownloadButton } from 'src/app/components/desktop-download/DesktopDownloadButton';

const Footer: FC = () => {
  const { classes } = useLayout();
  const history = useHistory();
  const go = (path: string) => {
    if (history.location.pathname !== path) history.push(path);
  };

  return (
    <div className="footer py-3 d-flex flex-lg-column flex-shrink-0 footer-responsive" id="kt_footer">
      <div className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center gap-2 gap-md-3`}>
        {/* Sol: sabit sticky ikonlar — görünürlük izinleri korunur */}
        <div className="footer-sticky-icons order-1">
          {/* Geri bildirim / destek talebi (soru işareti) — herkese açık */}
          <SupportFeedbackButton />
          {/* Masaüstü uygulaması indirme — yayın yoksa kendini gizler */}
          <DesktopDownloadButton />
          <button type="button" className="footer-sticky-icon footer-sticky-icon--primary" title="Sürüm Notları" onClick={() => go('/release-notes')}>
            <KTSVG path="/media/icons/duotone/Communication/RSS.svg" className="footer-sticky-icon__svg" />
          </button>
          <Restricted to="ROLE_LOGS">
            <button type="button" className="footer-sticky-icon footer-sticky-icon--info" title="Log Hareketleri" onClick={() => go('/logs')}>
              <KTSVG path="/media/icons/duotone/Communication/Clipboard-list.svg" className="footer-sticky-icon__svg" />
            </button>
          </Restricted>
          <Restricted to="ROLE_ADMIN">
            <button type="button" className="footer-sticky-icon footer-sticky-icon--success" title="Aktif Kullanıcılar" onClick={() => go('/admin/user-activity')}>
              <KTSVG path="/media/icons/duotone/Communication/Group.svg" className="footer-sticky-icon__svg" />
            </button>
          </Restricted>
        </div>

        <span className="footer-divider d-none d-md-block order-md-2" />

        {/* Orta: kişiselleştirilebilir kısayol çubuğu */}
        <div className="footer-shortcuts order-3 order-md-3 flex-grow-1 w-100">
          <ShortcutBar />
        </div>

        {/* Sağ: telif */}
        <div className="footer-copyright text-muted order-2 order-md-4">
          <span className="me-1">{new Date().getFullYear()} &copy;</span>
          <a href="mailto:cihancan.mustaoglu@aynetteknoloji.com.tr" className="text-gray-500 text-hover-primary">
            Cihancan MÜŞTAOĞLU
          </a>
        </div>
      </div>
    </div>
  );
};

export { Footer };
